import React from 'react'
import * as BasicIcons from 'components/icons/basic'

function IconList() {
  // Get all icon components from the basic icons export
  const iconEntries = Object.entries(BasicIcons)

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ marginBottom: '30px', textAlign: 'center' }}>
        <h1 style={{ color: '#333', marginBottom: '10px' }}>Icon Dictionary</h1>
        <p style={{ color: '#666', fontSize: '16px' }}>
          Development tool for viewing all available icons in the basic icon
          collection
        </p>
        <p style={{ color: '#999', fontSize: '14px' }}>
          Total icons: {iconEntries.length}
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '20px',
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        {iconEntries.map(([componentName, IconComponent]) => (
          <div
            key={componentName}
            style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              padding: '20px',
              backgroundColor: '#fff',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)'
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '80px',
                width: '80px',
                margin: '0 auto',
                marginBottom: '15px',
                backgroundColor: '#f8f9fa',
                borderRadius: '6px',
                border: '1px solid #e9ecef',
              }}
            >
              <IconComponent />
            </div>

            <div style={{ textAlign: 'center' }}>
              <h3
                style={{
                  margin: '0 0 8px 0',
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#333',
                  wordBreak: 'break-word',
                }}
              >
                {componentName}
              </h3>

              <div
                style={{
                  fontSize: '12px',
                  color: '#666',
                  backgroundColor: '#f1f3f4',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontFamily: 'monospace',
                  border: '1px solid #dadce0',
                }}
              >
                {`<${componentName} />`}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: '40px',
          textAlign: 'center',
          color: '#999',
          fontSize: '14px',
        }}
      >
        <p>This page is only available in development mode.</p>
        <p>
          Icons are located in: <code>src/js/components/icons/basic/</code>
        </p>
      </div>
    </div>
  )
}

export default IconList
